import closeWork from "./saleorder/reducer"
import customer from "./customer/reducer"

const productMangement = {
  closeWork,
  customer
};

export default productMangement;
